import { startAuthentication, startRegistration } from "@simplewebauthn/browser";
import api from "@/lib/api";

// A passkey is Face ID on an iPhone, a fingerprint on Android and Windows Hello on a laptop. The
// phone keeps the private key; we only ever see a public one.
export const passkeysSupported = () =>
  typeof window !== "undefined" && Boolean(window.PublicKeyCredential);

export const addPasskey = async (label = "") => {
  const { data } = await api.post("/auth/passkey/register/options");
  const credential = await startRegistration({ optionsJSON: JSON.parse(data.options) });
  const { data: saved } = await api.post("/auth/passkey/register/verify",
    { challenge_id: data.challenge_id, credential, label });
  return saved.credential;
};

export const unlockWithPasskey = async (scope, email = "") => {
  const { data } = await api.post("/auth/passkey/options", { scope, email });
  const credential = await startAuthentication({ optionsJSON: JSON.parse(data.options) });
  const { data: session } = await api.post("/auth/passkey/verify",
    { challenge_id: data.challenge_id, credential, scope });
  return session;
};

export const listPasskeys = async () =>
  (await api.get("/auth/passkey/credentials")).data.credentials;

export const removePasskey = (id) => api.delete(`/auth/passkey/credentials/${id}`);

// A cancelled or dismissed prompt is not a failure worth shouting about.
export const cancelled = (error) =>
  ["NotAllowedError", "AbortError"].includes(error?.name);
